export default __webpack_public_path__ + "bbc4cf3f4faa38d25eabcace3591f1e1.png";